import { activityHistoryFiltersSlice } from "../../slice";

export const { setUpFilterValues } = activityHistoryFiltersSlice.actions;
